import { useSnackbar } from 'notistack';
import { useApi } from '../../shared/context';
import { ProductSubscription, ProductSubscriptionSuccessFeeTier } from '../../shared/models';
import { useMutation, useQueryClient } from 'react-query';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CerebroTextButton } from '../../shared/components';
import { getResponseData } from '../../shared/utils/axios';
import { CerebroApiEndpoints } from '../../shared/utils/api';
import { QueryKeys } from '../../shared/hooks';

interface DeleteSuccessFeeTierDialogProps {
	dealGuid: string | undefined;
	subscription: ProductSubscription | null;
	tier: ProductSubscriptionSuccessFeeTier | null;
	close: () => void;
}

export const DeleteSuccessFeeTierDialog: React.FC<DeleteSuccessFeeTierDialogProps> = ({
	dealGuid,
	subscription,
	tier,
	close,
}) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onDeleteConfirmation = () => {
		if (tier !== null) deleteTier(tier);
	};

	const { mutate: deleteTier } = useMutation<void, unknown, ProductSubscriptionSuccessFeeTier>(
		tierToDelete =>
			getResponseData(
				api.delete<void>(
					CerebroApiEndpoints.Deals.SepcificSuccessFeeTiers(dealGuid, subscription?.guid, tierToDelete.guid)
				)
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.Deal.UpdateStatus(dealGuid));
				client.invalidateQueries(QueryKeys.Deal.SubscriptionTiers(dealGuid, subscription?.guid));
				snackbar.enqueueSnackbar('Subscription successfully deleted.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem deleting the deal engagement success fee tier.', {
					variant: 'error',
				});
			},
		}
	);

	return (
		<Dialog open={tier !== null} onClose={close}>
			<DialogTitle>Confirm Delete</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Are you sure you want to delete the deal engagement success fee tier?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onDeleteConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
